import { CreateProcessorExecutionResponse, ProcessorStepLog } from './executions-types';

export const createExecutionResponseMapper = (apiData: any): CreateProcessorExecutionResponse => {
  return apiData;
};

export const createProcessorStepLogListMapper = (apiData: any): ProcessorStepLog[] => {
  return apiData;
};
